export class StorageService {
  private readonly storage = window.localStorage

  public getItemStr(key: string): string | null {
    return this.storage.getItem(key)
  }

  public setItemStr(key: string, value: string): void {
    this.storage.setItem(key, value)
  }
}
